import { defineMessages } from 'react-intl';

export default defineMessages({
  thisSectionRelatedToMedicalExpenses: {
    id: 'fastCover.travellerMedicalBenefits.thisSectionRelatedToMedicalExpenses',
    defaultMessage: 'The section relates to medical expenses such as doctors visits, prescriptions or hospitalizations and similar services.',
  },
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.travellerMedicalBenefits.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  isRequired: {
    id: 'fastCover.travellerMedicalBenefits.isRequired',
    defaultMessage: '{defaultMessage} is required',
  },
  yes: {
    id: 'fastCover.travellerMedicalBenefits.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.travellerMedicalBenefits.no',
    defaultMessage: 'No',
  },
  checkboxDoctorVisit: {
    id: 'fastCover.travellerMedicalBenefits.checkboxDoctorVisit',
    defaultMessage: "Doctor's Visit",
  },
  questionDidYouHaveYourVisitByTelephoneOrVideoCall: {
    id: 'fastCover.travellerMedicalBenefits.questionDidYouHaveYourVisitByTelephoneOrVideoCall',
    defaultMessage: 'Did you have your visit by telephone or video call?',
  },
  headerTelemedicineBenefit: {
    id: 'fastCover.travellerMedicalBenefits.headerTelemedicineBenefit',
    defaultMessage: 'Telemedicine Benefit',
  },
  questionFirstVisitIllnessAccident: {
    id: 'fastCover.travellerMedicalBenefits.questionFirstVisitIllnessAccident',
    defaultMessage: 'Is this the first visit for the illness/accident?',
  },
  headerOutpatientPhysicianFees: {
    id: 'fastCover.travellerMedicalBenefits.headerOutpatientPhysicianFees',
    defaultMessage: 'Outpatient Physician Fees',
  },
  questionFollowUpVisit: {
    id: 'fastCover.travellerMedicalBenefits.questionFollowUpVisit',
    defaultMessage: 'Is this a follow up visit for a previously claimed illness or accident other than a fracture?',
  },
  headerFollowUpVisit: {
    id: 'fastCover.travellerMedicalBenefits.headerFollowUpVisit',
    defaultMessage: 'Follow Up Visit',
  },
  questionFollowUpVisitFracture: {
    id: 'fastCover.travellerMedicalBenefits.questionFollowUpVisitFracture',
    defaultMessage: 'Is this a follow up visit for a fracture?',
  },
  headerFractureTreatment: {
    id: 'fastCover.travellerMedicalBenefits.headerFractureTreatment',
    defaultMessage: 'Fracture Treatment',
  },
  tooltipFractureTreatment: {
    id: 'fastCover.travellerMedicalBenefits.tooltipFractureTreatment',
    defaultMessage: 'Please provide details of the fracture treatment expenses.',
  },
  noOngoingCareMessage: {
    id: 'fastCover.travellerMedicalBenefits.noOngoingCareMessage',
    defaultMessage: 'We do not cover visits for ongoing care. Please refer to your policy document for further detail.',
  },
  addItem: {
    id: 'fastCover.travellerMedicalBenefits.addItem',
    defaultMessage: 'Add Expense',
  },
  descriptionOfExpense: {
    id: 'fastCover.travellerMedicalBenefits.descriptionOfExpense',
    defaultMessage: 'Description of Expense',
  },
  dateOfExpense: {
    id: 'fastCover.travellerMedicalBenefits.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  amountClaimed: {
    id: 'fastCover.travellerMedicalBenefits.amountClaimed',
    defaultMessage: 'Amount Claimed',
  },
  currency: {
    id: 'fastCover.travellerMedicalBenefits.currency',
    defaultMessage: 'Currency',
  },
  providerName: {
    id: 'fastCover.travellerMedicalBenefits.providerName',
    defaultMessage: 'Provider Name',
  },
  checkEventDate: {
    id: 'fastCover.travellerMedicalBenefits.checkEventDate',
    defaultMessage: '{defaultMessage} is not a valid date',
  },
  expenseFor: {
    id: 'fastCover.travellerMedicalBenefits.expenseFor',
    defaultMessage: 'Expense For',
  },
  selectInsuredForExpense: {
    id: 'fastCover.travellerMedicalBenefits.selectInsuredForExpense',
    defaultMessage: 'Please select the insured(s) for this expense',
  },

  // Diagnostic Tests
  checkboxDiagnosticTests: {
    id: 'fastCover.travellerMedicalBenefits.checkboxDiagnosticTests',
    defaultMessage: 'Diagnostic Tests',
  },
  headerDiagnosticTests: {
    id: 'fastCover.travellerMedicalBenefits.headerDiagnosticTests',
    defaultMessage: 'Diagnostic Tests',
  },

  // Prescription Drugs
  checkboxPrescriptionDrugs: {
    id: 'fastCover.travellerMedicalBenefits.checkboxPrescriptionDrugs',
    defaultMessage: 'Prescription Drugs',
  },
  headerPrescriptionDrugs: {
    id: 'fastCover.travellerMedicalBenefits.headerPrescriptionDrugs',
    defaultMessage: 'Prescription Drugs',
  },
  headerPrescriptionDrugsLost: {
    id: 'fastCover.travellerMedicalBenefits.headerPrescriptionDrugsLost',
    defaultMessage: 'Prescription Drugs - lost, stolen or damaged',
  },
  questionReplacingLostStolenDamagedPrescriptionDrugs: {
    id: 'fastCover.travellerMedicalBenefits.questionReplacingLostStolenDamagedPrescriptionDrugs',
    defaultMessage: 'Are you replacing lost, stolen, or damaged prescription drugs?',
  },

  // Ambulance Services
  checkboxAmbulanceServices: {
    id: 'fastCover.travellerMedicalBenefits.checkboxAmbulanceServices',
    defaultMessage: 'Ambulance Services',
  },
  questionGroundAmbulance: {
    id: 'fastCover.travellerMedicalBenefits.questionGroundAmbulance',
    defaultMessage: 'Is your invoice for a ground ambulance?',
  },
  headerGroundAmbulance: {
    id: 'fastCover.travellerMedicalBenefits.headerGroundAmbulance',
    defaultMessage: 'Ground Ambulance',
  },
  questionAirAmbulance: {
    id: 'fastCover.travellerMedicalBenefits.questionAirAmbulance',
    defaultMessage: 'Is your invoice for an Air Ambulance?',
  },
  headerAirAmbulance: {
    id: 'fastCover.travellerMedicalBenefits.headerAirAmbulance',
    defaultMessage: 'Air Ambulance',
  },
  headerOtherAmbulance: {
    id: 'fastCover.travellerMedicalBenefits.headerOtherAmbulance',
    defaultMessage: 'Other Types of Ambulances',
  },

  // Hospitalization
  checkboxHospitalization: {
    id: 'fastCover.travellerMedicalBenefits.checkboxHospitalization',
    defaultMessage: 'Hospitalization',
  },
  headerHospitalFees: {
    id: 'fastCover.travellerMedicalBenefits.headerHospitalFees',
    defaultMessage: 'Hospital Fees',
  },
  headerInpatientPhysicianFees: {
    id: 'fastCover.travellerMedicalBenefits.headerInpatientPhysicianFees',
    defaultMessage: 'Physician Fees while hospitalized',
  },
  headerXrayLabsDiagnostics: {
    id: 'fastCover.travellerMedicalBenefits.headerXrayLabsDiagnostics',
    defaultMessage: 'Expenses for X-Ray, Labs, or other diagnostics while hospitalized',
  },
  headerEmergencyAirTransportation: {
    id: 'fastCover.travellerMedicalBenefits.headerEmergencyAirTransportation',
    defaultMessage: 'Emergency Air Transportation that was approved by us in advance',
  },
  headerAirfareReturnHome: {
    id: 'fastCover.travellerMedicalBenefits.headerAirfareReturnHome',
    defaultMessage: 'Airfare to Return Home For Treatment Benefit that was approved by us in advance',
  },
  headerFamilyTransportation: {
    id: 'fastCover.travellerMedicalBenefits.headerFamilyTransportation',
    defaultMessage: 'Family Transportation expenses approved by us in advance',
  },
  headerFamilyTransportationMealsAccommodation: {
    id: 'fastCover.travellerMedicalBenefits.headerFamilyTransportationMealsAccommodation',
    defaultMessage: 'Family Transportation Meals and accommodation costs approved by us in advance',
  },
  headerMedicalAttendant: {
    id: 'fastCover.travellerMedicalBenefits.headerMedicalAttendant',
    defaultMessage: 'Medical Attendant that was approved by us in advance',
  },
  tooltipMedicalAttendant: {
    id: 'fastCover.travellerMedicalBenefits.tooltipMedicalAttendant',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit or the Airfare to Return Home for treatment benefit.',
  },
  headerReturnOfTravellingCompanion: {
    id: 'fastCover.travellerMedicalBenefits.headerReturnOfTravellingCompanion',
    defaultMessage: 'Return of Travelling Companion that was approved by us in advance',
  },
  tooltipReturnOfTravellingCompanion: {
    id: 'fastCover.travellerMedicalBenefits.tooltipReturnOfTravellingCompanion',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit, the Airfare to Return Home for treatment benefit, or the Repatriation benefit.',
  },
  headerReturnOfDependentChildren: {
    id: 'fastCover.travellerMedicalBenefits.headerReturnOfDependentChildren',
    defaultMessage: 'Return of Dependent Children that was approved by us in advance',
  },
  tooltipReturnOfDependentChildren: {
    id: 'fastCover.travellerMedicalBenefits.tooltipReturnOfDependentChildren',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit, the Airfare to Return Home for treatment benefit, or the Repatriation benefit.',
  },
  headerHospitalAllowance: {
    id: 'fastCover.travellerMedicalBenefits.headerHospitalAllowance',
    defaultMessage: 'Hospital allowance',
  },
  tooltipHospitalAllowance: {
    id: 'fastCover.travellerMedicalBenefits.tooltipHospitalAllowance',
    defaultMessage: 'Up to $100 per day to cover TV rental or telephone charges which are billed by the hospital',
  },
  headerOutOfPocketExpenses: {
    id: 'fastCover.travellerMedicalBenefits.headerOutOfPocketExpenses',
    defaultMessage: 'Out-Of-Pocket Expenses',
  },
  tooltipOutOfPocketExpenses: {
    id: 'fastCover.travellerMedicalBenefits.tooltipOutOfPocketExpenses',
    defaultMessage: 'Up to $500 per day to a maximum of $5,000 for your commercial accommodation, meals, telephone calls, internet charges, taxi fare, parking charges, bus fare and rental car under the circumstances listed in your policy document',
  },
  headerChildcare: {
    id: 'fastCover.travellerMedicalBenefits.headerChildcare',
    defaultMessage: 'Childcare',
  },
  tooltipChildcare: {
    id: 'fastCover.travellerMedicalBenefits.tooltipChildcare',
    defaultMessage: 'Up to $500 per day to a maximum of $5,000 for child care costs for insured children 18 years and under who are travelling with you (excluding child care provided by a family member) when you are hospitalized.',
  },
  headerHospitalizationReturnOfVehicle: {
    id: 'fastCover.travellerMedicalBenefits.headerHospitalizationReturnOfVehicle',
    defaultMessage: 'Return of Vehicle',
  },
  tooltipHospitalizationReturnOfVehicle: {
    id: 'fastCover.travellerMedicalBenefits.tooltipHospitalizationReturnOfVehicle',
    defaultMessage: 'This benefit can be claimed if the attending physician determines that as a result of an emergency, you are incapable of continuing your trip by means of the vehicle used to depart from your province or territory of residence and the vehicle you intended to use to return to your province or territory of residence and your travelling companion is unable to do so for you.',
  },

  headerOtherHospitalizationRelated: {
    id: 'fastCover.travellerMedicalBenefits.headerOtherHospitalizationRelated',
    defaultMessage: 'Other expenses related to hospitalization',
  },
  headerAirlineSeatUpgrade: {
    id: 'fastCover.travellerMedicalBenefits.headerAirlineSeatUpgrade',
    defaultMessage: 'Airline Seat Upgrade when medically required by the attending physician',
  },
  expenseBoxHeaderAirlineSeatUpgrade: {
    id: 'fastCover.travellerMedicalBenefits.expenseBoxHeaderAirlineSeatUpgrade',
    defaultMessage: 'Airline Seat Upgrade',
  },
  headerReturnOfPets: {
    id: 'fastCover.travellerMedicalBenefits.headerReturnOfPets',
    defaultMessage: 'Return of Pets',
  },
  tooltipReturnOfPets: {
    id: 'fastCover.travellerMedicalBenefits.tooltipReturnOfPets',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit,  the Airfare to Return Home for treatment benefit, or the Repatriation benefit.',
  },

  headerMedicalFollowUpInCanada: {
    id: 'fastCover.travellerMedicalBenefits.headerMedicalFollowUpInCanada',
    defaultMessage: 'Medical Follow-Up in Canada',
  },
  headerMedicalFollowUpInCanadaSemiPrivate: {
    id: 'fastCover.travellerMedicalBenefits.headerMedicalFollowUpInCanadaSemiPrivate',
    defaultMessage: 'Follow-Up in Canada - Semi Private room',
  },
  headerMedicalFollowUpInCanadaAmbulance: {
    id: 'fastCover.travellerMedicalBenefits.headerMedicalFollowUpInCanadaAmbulance',
    defaultMessage: 'Follow-Up in Canada - Ambulance or Taxi',
  },
  headerMedicalFollowUpInCanadaHomeCare: {
    id: 'fastCover.travellerMedicalBenefits.headerMedicalFollowUpInCanadaHomeCare',
    defaultMessage: 'Follow-Up in Canada - Home Care Nursing',
  },
  headerMedicalFollowUpInCanadaEssentialMedicalApp: {
    id: 'fastCover.travellerMedicalBenefits.headerMedicalFollowUpInCanadaEssentialMedicalApp',
    defaultMessage: 'Follow-Up in Canada - Essential Medical Appliances',
  },
  tooltipMedicalFollowUpInCanada: {
    id: 'fastCover.travellerMedicalBenefits.tooltipMedicalFollowUpInCanada',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit,  the Airfare to Return Home for treatment benefit, after being hospitalized during your Trip.',
  },
  headerReturnToYourDestination: {
    id: 'fastCover.travellerMedicalBenefits.headerReturnToYourDestination',
    defaultMessage: 'Return to Your Destination',
  },
  tooltipReturnToYourDestination: {
    id: 'fastCover.travellerMedicalBenefits.tooltipReturnToYourDestination',
    defaultMessage: 'This is only available if you have claimed Emergency Air Transportation benefit,  the Airfare to Return Home for treatment benefit, after being hospitalized during your Trip.',
  },
  expenseBoxHeaderOtherHospitalizationRelated: {
    id: 'fastCover.travellerMedicalBenefits.expenseBoxHeaderOtherHospitalizationRelated',
    defaultMessage: 'Other hospital expenses',
  },

  // Return of Vehicle (standalone)
  checkboxReturnOfVehicle: {
    id: 'fastCover.travellerMedicalBenefits.checkboxReturnOfVehicle',
    defaultMessage: 'Return of Vehicle that was preapproved by us',
  },
  headerReturnOfVehicle: {
    id: 'fastCover.travellerMedicalBenefits.headerReturnOfVehicle',
    defaultMessage: 'Return of Vehicle',
  },
  tooltipReturnOfVehicle: {
    id: 'fastCover.travellerMedicalBenefits.tooltipReturnOfVehicle',
    defaultMessage: 'This benefit can be claimed if the attending physician determines that as a result of an emergency, you are incapable of continuing your trip by means of the vehicle used to depart from your province or territory of residence and the vehicle you intended to use to return to your province or territory of residence and your travelling companion is unable to do so for you.',
  },

  // Essential Medical Equipment
  checkboxEssentialMedicalEquipment: {
    id: 'fastCover.travellerMedicalBenefits.checkboxEssentialMedicalEquipment',
    defaultMessage: 'Essential Medical Equipment',
  },
  tooltipEssentialMedicalEquipment: {
    id: 'fastCover.travellerMedicalBenefits.tooltipEssentialMedicalEquipment',
    defaultMessage: 'Expenses related to the cost of renting essential medical equipment such as crutches or wheelchair.',
  },
  headerEssentialMedicalEquipment: {
    id: 'fastCover.travellerMedicalBenefits.headerEssentialMedicalEquipment',
    defaultMessage: 'Essential Medical Equipment',
  },

  // Private Duty Nursing
  checkboxPrivateDutyNursing: {
    id: 'fastCover.travellerMedicalBenefits.checkboxPrivateDutyNursing',
    defaultMessage: 'Private Duty Nursing',
  },
  tooltipPrivateDutyNursing: {
    id: 'fastCover.travellerMedicalBenefits.tooltipPrivateDutyNursing',
    defaultMessage: 'Private duty nursing must be performed by an RN other than a family member when ordered in writing by the attending physician.',
  },
  headerPrivateDutyNursing: {
    id: 'fastCover.travellerMedicalBenefits.headerPrivateDutyNursing',
    defaultMessage: 'Private Duty Nursing',
  },

  // Fracture Treatment (standalone checkbox)
  checkboxFractureTreatmentStandalone: {
    id: 'fastCover.travellerMedicalBenefits.checkboxFractureTreatmentStandalone',
    defaultMessage: 'Fracture Treatment',
  },
  tooltipFractureTreatmentStandalone: {
    id: 'fastCover.travellerMedicalBenefits.tooltipFractureTreatmentStandalone',
    defaultMessage: 'This can include the cost of x-rays, reexamination by a physician, casting, re-casting and cast removal. Fracture benefit does not apply if you have claimed Airfare to Return Home for Treatment.',
  },
  headerFractureTreatmentStandalone: {
    id: 'fastCover.travellerMedicalBenefits.headerFractureTreatmentStandalone',
    defaultMessage: 'Fracture Treatment',
  },

  // Maternity Benefits
  checkboxUnexpectedBirthOfChild: {
    id: 'fastCover.travellerMedicalBenefits.checkboxUnexpectedBirthOfChild',
    defaultMessage: 'Unexpected Birth of a Child',
  },
  dateOfConception: {
    id: 'fastCover.travellerMedicalBenefits.dateOfConception',
    defaultMessage: 'Please enter the date of conception:',
  },
  dateOfConceptionTooltip: {
    id: 'fastCover.travellerMedicalBenefits.dateOfConceptionTooltip',
    defaultMessage: 'Conception means the date your pregnancy began, not when you discovered you were pregnant',
  },
  anticipatedDueDate: {
    id: 'fastCover.travellerMedicalBenefits.anticipatedDueDate',
    defaultMessage: 'Please enter your anticipated due date:',
  },
  headerUnexpectedBirthOfChild: {
    id: 'fastCover.travellerMedicalBenefits.headerUnexpectedBirthOfChild',
    defaultMessage: 'Unexpected Birth of a Child',
  },

  // Dental Services
  checkboxDentalServices: {
    id: 'fastCover.travellerMedicalBenefits.checkboxDentalServices',
    defaultMessage: 'Dental Services',
  },
  dentalServicesDentalAccident: {
    id: 'fastCover.travellerMedicalBenefits.dentalServicesDentalAccident',
    defaultMessage: 'Dental Accident (result of a blow to the face)',
  },
  dentalServicesDentalPainOther: {
    id: 'fastCover.travellerMedicalBenefits.dentalServicesDentalPainOther',
    defaultMessage: 'Dental pain other than accident',
  },
  headerDentalAccident: {
    id: 'fastCover.travellerMedicalBenefits.headerDentalAccident',
    defaultMessage: 'Dental Accident',
  },
  headerDentalPain: {
    id: 'fastCover.travellerMedicalBenefits.headerDentalPain',
    defaultMessage: 'Dental Pain',
  },

  // Professional Services
  checkboxProfessionalServices: {
    id: 'fastCover.travellerMedicalBenefits.checkboxProfessionalServices',
    defaultMessage: 'Professional Services',
  },
  professionalServicesDescription: {
    id: 'fastCover.travellerMedicalBenefits.professionalServicesDescription',
    defaultMessage: 'These benefits are only eligible when they are ordered by a physician at the time of, and as a result of your emergency.',
  },
  professionalServicesPhysiotherapist: {
    id: 'fastCover.travellerMedicalBenefits.professionalServicesPhysiotherapist',
    defaultMessage: 'Physiotherapist',
  },
  professionalServicesChiropractor: {
    id: 'fastCover.travellerMedicalBenefits.professionalServicesChiropractor',
    defaultMessage: 'Chiropractor',
  },
  professionalServicesChiropodist: {
    id: 'fastCover.travellerMedicalBenefits.professionalServicesChiropodist',
    defaultMessage: 'Chiropodist',
  },
  professionalServicesOsteopath: {
    id: 'fastCover.travellerMedicalBenefits.professionalServicesOsteopath',
    defaultMessage: 'Osteopath',
  },
  professionalServicesPodiatrist: {
    id: 'fastCover.travellerMedicalBenefits.professionalServicesPodiatrist',
    defaultMessage: 'Podiatrist',
  },
  professionalServicesAcupuncturist: {
    id: 'fastCover.travellerMedicalBenefits.professionalServicesAcupuncturist',
    defaultMessage: 'Acupuncturist',
  },
  professionalServicesOptometrist: {
    id: 'fastCover.travellerMedicalBenefits.professionalServicesOptometrist',
    defaultMessage: 'Optometrist',
  },
  professionalServicesSelectOneRequired: {
    id: 'fastCover.travellerMedicalBenefits.professionalServicesSelectOneRequired',
    defaultMessage: 'Please select at least one professional service or uncheck Professional Services.',
  },

  // Expenses Related to Death (Standard VTC Medical Benefits)
  checkboxExpensesRelatedToDeath: {
    id: 'fastCover.travellerMedicalBenefits.checkboxExpensesRelatedToDeath',
    defaultMessage: 'Expenses Related to Death',
  },
  tooltipExpensesRelatedToDeath: {
    id: 'fastCover.travellerMedicalBenefits.tooltipExpensesRelatedToDeath',
    defaultMessage:
      'Expenses related to death are payable only when pre-approved by us. Charges for funeral expenses, coffin or urn are not eligible for reimbursement.',
  },
  headerExpensesRelatedToDeathReturnOfRemains: {
    id: 'fastCover.travellerMedicalBenefits.headerExpensesRelatedToDeathReturnOfRemains',
    defaultMessage: 'Return of remains to home country',
  },
  headerExpensesRelatedToDeathBurialOrCremationAtPlaceOfDeath: {
    id: 'fastCover.travellerMedicalBenefits.headerExpensesRelatedToDeathBurialOrCremationAtPlaceOfDeath',
    defaultMessage: 'Burial or Cremation at Place of Death',
  },
  headerExpensesRelatedToDeathTransportationOfFamilyMemberToIdentifyBody: {
    id: 'fastCover.travellerMedicalBenefits.headerExpensesRelatedToDeathTransportationOfFamilyMemberToIdentifyBody',
    defaultMessage: 'Transportation of Family Member to Identify Remains when required',
  },

  // Remote Evacuation
  checkboxRemoteEvacuation: {
    id: 'fastCover.travellerMedicalBenefits.checkboxRemoteEvacuation',
    defaultMessage: 'Remote Evacuation',
  },
  headerRemoteEvacuation: {
    id: 'fastCover.travellerMedicalBenefits.headerRemoteEvacuation',
    defaultMessage: 'Remote Evacuation',
  },
  tooltipRemoteEvacuation: {
    id: 'fastCover.travellerMedicalBenefits.tooltipRemoteEvacuation',
    defaultMessage: 'Up to a maximum of $6,000 for reimbursement of expenses for non-medical emergency evacuation from a remote location by professional services to the nearest accessible point. This includes search and rescue services for mountain, sea or other remote locations.',
  },

  // Vision Care and Hearing Aids
  checkboxVisionCareHearingAids: {
    id: 'fastCover.travellerMedicalBenefits.checkboxVisionCareHearingAids',
    defaultMessage: 'Replacement of Prescription Glasses, Sunglasses, Contact Lenses or Hearing Aid (theft, loss, or breakage only)',
  },
  headerVisionCareHearingAids: {
    id: 'fastCover.travellerMedicalBenefits.headerVisionCareHearingAids',
    defaultMessage: 'Vision Care and/or Hearing Aids',
  },

  // Air Travel Delay
  checkboxAirTravelDelay: {
    id: 'fastCover.travellerMedicalBenefits.checkboxAirTravelDelay',
    defaultMessage: 'Air Travel Delay',
  },
  airTravelDelayHotelOrRestaurant: {
    id: 'fastCover.travellerMedicalBenefits.airTravelDelayHotelOrRestaurant',
    defaultMessage: 'Hotel, motel or restaurant expenses if your flight has been delayed for more than 4 hours',
  },
  airTravelDelayAdditionalTransport: {
    id: 'fastCover.travellerMedicalBenefits.airTravelDelayAdditionalTransport',
    defaultMessage: 'Additional transport expenses if your flight has been delayed for more than 4 hours',
  },
  airTravelDelayEntertainment: {
    id: 'fastCover.travellerMedicalBenefits.airTravelDelayEntertainment',
    defaultMessage: 'Entertainment expenses if your flight has been delayed for more than 4 hours',
  },
  airTravelDelayEssentialClothing: {
    id: 'fastCover.travellerMedicalBenefits.airTravelDelayEssentialClothing',
    defaultMessage: 'Essential Clothing and Personal Care Items if your baggage has been lost or delayed by the airline for more than 6 hours.',
  },
  headerAirTravelDelayHotelOrRestaurant: {
    id: 'fastCover.travellerMedicalBenefits.headerAirTravelDelayHotelOrRestaurant',
    defaultMessage: 'Air Travel Delay - Hotel or Restaurant',
  },
  headerAirTravelDelayAdditionalTransport: {
    id: 'fastCover.travellerMedicalBenefits.headerAirTravelDelayAdditionalTransport',
    defaultMessage: 'Air Travel Delay - Additional Transport',
  },
  headerAirTravelDelayEntertainment: {
    id: 'fastCover.travellerMedicalBenefits.headerAirTravelDelayEntertainment',
    defaultMessage: 'Air Travel Delay - Entertainment Expenses',
  },
  headerAirTravelDelayEssentialClothing: {
    id: 'fastCover.travellerMedicalBenefits.headerAirTravelDelayEssentialClothing',
    defaultMessage: 'Air Travel Delay - Essential Clothing and Personal Care',
  },

  // Other (unrelated to any benefit listed above)
  checkboxOtherUnrelatedBenefit: {
    id: 'fastCover.travellerMedicalBenefits.checkboxOtherUnrelatedBenefit',
    defaultMessage: 'Other (unrelated to any benefit listed above)',
  },
  headerOtherUnrelatedBenefit: {
    id: 'fastCover.travellerMedicalBenefits.headerOtherUnrelatedBenefit',
    defaultMessage: 'Other (unrelated to any benefit listed above)',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.TravellerMedicalBenefits/messages.js